export interface IProviderService {
    providerServiceId: number;
    providerId: number;
    serviceId: number;
    serviceName: string;
    active: boolean;
    createdBy: number;
    createdDate: Date;
}
